import React from 'react';
import { connectModal } from 'redux-modal';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addCar } from '../../actions/carActions';
import CarForm from './CarForm';

function NewCarModal({ handleHide }) {
  const dispatch = useDispatch();

  function handleSubmit(values, { resetForm }) {
    const car = {
      name: values.carBrand,
      primary: values.favourite,
      plateNo: values.carPlate
    };
    const dispatchAdd = dispatch(addCar(car));
    dispatchAdd
      .then(() => {
        toast.success(`Přidali jste si nové auto ${car.name}`);
        handleHide();
        resetForm();
      })
      .catch(() => {
        toast.error(`Něco se nepovedlo, zkontrolujte si informace o autě`);
      });
  }

  return (
    <div className="modal">
      <div className="modal__container">
        <div className="modal__body">
          <h2>Přidat auto</h2>
          <CarForm
            handleSubmit={handleSubmit}
            initialValues={{ carPlate: '', carBrand: '', favourite: false }}
          />
        </div>
      </div>
    </div>
  );
}

export default connectModal({ name: 'newCarModal' })(NewCarModal);
